module.exports = function() {
  return new Worker("/" + "sass-transpiler.a60c5eda.worker.js");
};